import React, { Component } from "react";
import fees from "../assets/icon/fees.png";
import rate from "../assets/icon/rate.png";
import secure from "../assets/icon/secure.png";
import simple from "../assets/icon/simple.png";
import "./choose.css";

class Choose extends Component {
  state = {};
  render() {
    return (
      <div className="bg">
        <div className="container">
          <h1 className="Why-choose-Yoti-Exch"> Why choose Yoti Exchange</h1>
          <div className="row">
            <div className="col-3">
              <img src={secure} alt="" className="m-1 img-fluid" />
            </div>
            <div className="col-3">
              <img src={simple} alt="" className="m-1 img-fluid" />
            </div>
            <div className="col-3">
              <img src={fees} alt="" className="m-1 img-fluid" />
            </div>
            <div className="col-3">
              <img src={rate} alt="" className="m-1 img-fluid" />
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <h3 className="hh3">Secure</h3>
            </div>
            <div className="col-3">
              <h3 className="hh3">Simple</h3>
            </div>
            <div className="col-3">
              <h3 className="hh3">No hidden fees</h3>
            </div>
            <div className="col-3">
              <h3 className="hh3">Best rate</h3>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Choose;
